import _get from 'lodash/get';
import { useEffect, useRef, useState } from 'react';

export const usePrimaryNav = () => {
  const navbarRef = useRef(null);

  const [expanded, setExpanded] = useState();

  // collapse navbar on nav link click

  useEffect(() => {
    let timeoutId;

    if (!navbarRef || !navbarRef.current) {
      return;
    }

    const navBarEl = navbarRef.current;

    const dropdownEls = navBarEl.querySelectorAll('.nav-dropdown-wrapper');

    const handleDropdownMouseEnter = e => {
      timeoutId = setTimeout(() => {
        const el = e.target;

        el.classList.add('shown');
      }, 0);
    };

    const handleDropdownMouseLeave = e => {
      clearTimeout(timeoutId);

      const el = e.target;

      el.classList.remove('shown');
    };

    const handleNavLinkClick = e => {
      const tagName = _get(e, 'target.tagName', '');

      if (tagName.toLowerCase() === 'a') {
        setExpanded(false);

        if (dropdownEls) {
          dropdownEls.forEach(item => item.classList.remove('shown'));
        }
      }
    };

    navBarEl.addEventListener('click', handleNavLinkClick);

    if (dropdownEls) {
      dropdownEls.forEach(item =>
        item.addEventListener('mouseenter', handleDropdownMouseEnter)
      );

      dropdownEls.forEach(item =>
        item.addEventListener('mouseleave', handleDropdownMouseLeave)
      );
    }

    return () => {
      navBarEl.removeEventListener('click', handleNavLinkClick);

      clearTimeout(timeoutId);

      if (dropdownEls) {
        dropdownEls.forEach(item =>
          item.removeEventListener('mouseenter', handleDropdownMouseEnter)
        );

        dropdownEls.forEach(item =>
          item.removeEventListener('mouseleave', handleDropdownMouseLeave)
        );
      }
    };
  }, [navbarRef]);

  return { ref: navbarRef, expanded, setExpanded };
};
